import { Flex } from '@chakra-ui/react';
import { DisclaimerType, IDisclaimer } from '@llx/common';

import ImageDisclaimer from './ImageDisclaimer';
import PoweredByDisclaimer from './PoweredByDisclaimer';

type Props = {
  casePath: string;
  disclaimer: IDisclaimer;
};

function CaseDisclaimerView({ disclaimer, casePath }: Props) {
  // image disclaimer will take full screen size
  if (disclaimer.type === DisclaimerType.IMAGE) {
    return (
      <Flex
        className="disclaimerContainer"
        top="0"
        left="0"
        right="0"
        position="fixed"
        zIndex="100"
        background="white"
        height="100%"
        width="100%"
        alignItems="center"
        justifyContent="center"
      >
        <ImageDisclaimer disclaimer={disclaimer} casePath={casePath} />
      </Flex>
    );
  }

  // other type of disclaimer (powered by, etc.)
  return (
    <Flex
      className="disclaimerContainer"
      position="relative"
      background="white"
      height="100%"
      width="100%"
      padding="50px 30px"
      alignItems="center"
    >
      <Flex
        position="relative"
        width="100%"
        height="100%"
        flexDirection="column"
        className="content"
        alignItems="center"
      >
        {disclaimer.type === DisclaimerType.POWERED_BY && (
          <PoweredByDisclaimer disclaimer={disclaimer} casePath={casePath} />
        )}
      </Flex>
    </Flex>
  );
}

export default CaseDisclaimerView;
